import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportSecurityCategoryOverwriteDialogComponent } from './import-security-category-overwrite-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportSecurityCategoryOverwriteGridLayoutService implements GridLayoutService<ImportSecurityCategoryOverwriteDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Symbol',            
            field: 'name',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
            maxWidth: 200,
            width: 200
            
        },
        {
            headerName: 'Old Category',
            field: 'status',
            cellRenderer: 'cellRendererFormatter',
            cellRendererParams: {
                text: (params: any) => {
                  return (params.value != null && params.value.length > 0);
              }
          },
          width: 235
        },
        {
            headerName: 'New Category',
            field: 'action',
            cellRendererSelector: (params: any) => {
            let finalValue = '';
            if (params.data) {
              if (params.data.action != null && params.data.action.length > 0) {
                finalValue = params.data.action;
              } else {
                finalValue = "Uncategorized";
              }
            }
            return {
              component: 'cellRendererFormatter',
              params: { value: finalValue }
            };
          },
          maxWidth: 170,
          width: 170
        }];
    }
}
